module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-blob-2-ab283c20e8e2c838efb1bee908855f84.svg";